import { FormSwitch } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { ProtocolSendFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

export function ProtocolSendForm() {
	/** Context */
	const methods = useFormContext<ProtocolSendFormSchema>();
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack gap-2">
			<FormSwitch
				control={methods.control}
				name="withAttachment"
			>
				{t("protocols.send_with_attachment")}
			</FormSwitch>
			<FormSwitch
				control={methods.control}
				name="sendCopyToCreator"
			>
				{t("protocols.send_copy_to_me")}
			</FormSwitch>
		</div>
	);
}
